<script>
import Utils from '../../Utils'

const supPourcent = 'span .line .date';
const dark = 'dark';

const supPourcentCard = 'span .line.grey .date';
const subPourcentCard = 'span .line:not([grey]) .date';
const darkCard = 'dark';

let pourcent = '';

export default {
  name: "Card",
  components:{ 
  },
  data(){
    return {
        max: 100,
        value: 0,
        valueTwo: 0, 
        isNegative : false,
        difference:0,
        pourcentYear: 0,
        supPourcentCard: this.supPourcentCard,
        subPourcentCard: this.subPourcentCard
    }
  },
  methods : {
    getNegatifOrNot(number){
      this.isNegative = Utils.getFirstLetter(number);
    },
    getPourcentByYear(){
      let weekNumber = 52;
      let numberOfWeek = Utils.getNumberOfWeek();
      this.pourcentYear = (numberOfWeek/weekNumber)*100;
    },
    getPourcent(){
      let pourcent = '';
      let dateTarget = null;

      pourcent = Math.round((parseInt(this.resultOne, 10) / parseInt(this.objective, 10))*100);
      this.value = pourcent;
      if(pourcent <= 50){
        dateTarget = this.$el.querySelector(supPourcent);
        dateTarget?dateTarget.classList.add(dark): '';
        dateTarget?dateTarget.style.left = `${pourcent < 0 ? 0 : pourcent}%`: '';
       
      } 
    },  
    getPourcentBetween(value,valueTwo){
      let valueTop = parseFloat(value);
      let valueBottom  = parseFloat(valueTwo);
      let result = '';

      if (valueTop === '-') {
        this.value = '-';
        this.valueTwo = 100;
        this.isNegative = false;
        return;
      }
      if (valueTwo === '-') {
        this.value = 100;
        this.valueTwo = '-';
        this.isNegative = false;
        return;
      }

      if( valueTop >= valueBottom ){
          pourcent = Math.round((valueBottom / valueTop)*100);
          result =  Math.round(valueTop - valueBottom);
          this.difference = result;
          this.isNegative = false;

          valueBottom = pourcent;
          valueTop = 100;

          if(pourcent <= 50){
            this.addClassTo(supPourcentCard);
          }

      } else {
          pourcent = Math.round((valueTop / valueBottom)*100);
          result =  Math.round(valueBottom - valueTop);
          this.difference = result;
          this.isNegative = true;

          valueTop = pourcent;
          valueBottom = 100;

          if(pourcent <= 50){
            this.addClassTo(subPourcentCard);
          }
      }

      this.value = valueTop;
      this.valueTwo = valueBottom;

    },  
    addClassTo(target){
      let date = null;
          date = this.$el.querySelector(target);
          date ? date.classList.add(darkCard):'';
          date ? date.style.left = `${pourcent < 0 ? 0 : pourcent}%`:'';
    },

  }
}
</script>
